import { useLayoutContext } from '../../Layout/LayoutProvider/LayoutContext';
import { useAccessibilityContext } from '../../Providers/AccessibilityProvider/AccessibilityContext';

const useAccesibilityActions = () => {
  const { fontSize, setFontSize } = useAccessibilityContext();

  function changeSizeFontMinus() {
    const fonts = document.querySelectorAll(
      'span:not(.glyphicon), p, a, h1, h2, h3, h4, h5, input, div,strong:not(.fa), font'
    );
    fonts.forEach((el: any) => {
      if (fontSize != undefined && fontSize > -5) {
        const style = window.getComputedStyle(el);
        const currentFontSize = parseFloat(style.fontSize);
        el.style.fontSize = `${currentFontSize - 0.5}px`;
        if (setFontSize) {
          setFontSize(fontSize - 0.5);
        }
      }
    });
  }

  function changeSizeFontPlus() {
    const fonts = document.querySelectorAll(
      'span:not(.glyphicon), p, a, h1, h2, h3, h4, h5, input, div,strong:not(.fa)'
    );
    fonts.forEach((el: any) => {
      if (fontSize != undefined && fontSize < 5) {
        const style = window.getComputedStyle(el);
        const currentFontSize = parseFloat(style.fontSize);
        el.style.fontSize = `${currentFontSize + 0.5}px`;
        if (setFontSize) {
          setFontSize(fontSize + 0.5);
        }
      }
    });
  }

  const {
    layout: { setIsHightContrast, isHightContrast },
  } = useLayoutContext();

  function toggleHightContrast() {
    if (setIsHightContrast) {
      setIsHightContrast(!isHightContrast);
    }
  }

  return { changeSizeFontPlus, changeSizeFontMinus, toggleHightContrast };
};

export default useAccesibilityActions;
